module.exports = __webpack_public_path__ + "media/country_flags/bd-5f371b3b.png";